import React from "react";
import "../assets/css/spinner.css";

const Spinner = () => {
  return (
    <div className="loaderContainer">
      <div className="loader"></div>
    </div>
  );
};

export default Spinner;
